import Grid from "@mui/material/Grid";
import { Box, Stack } from "@mui/material";
import { LabelTemplate } from "./styles/table";
import { Employee } from "../types/processTypes";

import { BasicPostApplied } from "./components/basic/BasicPostApplied";
import { BasicDetail } from "./components/basic/BasicDetail";
import { BasicLanguageLevels } from "./components/basic/BasicLanguage";
import { BasicExperience } from "./components/basic/BasicExperience";
import Image from "mui-image";

import { BasicSkillsSmallHorzTwoLines } from "./components/basic/BasicSkills";
import { BasicPassport } from "./components/basic/BasicPassport";
import { BasicFullName } from "./components/basic/BasicFullName";
import { BasicFace } from "./components/basic/BasicFace";
import { BasicStand } from "./components/basic/BasicStand";
import { BasicReferenceOnly } from "./components/basic/BasicReference";
import { BasicPassportScan } from "./components/basic/BasicPassportScan";
import { BasicHeader } from "./components/basic/BasicHeader";
import { Company } from "../../setups/types/setupTypes";
import { BasicTitleSingleLang } from "./components/basic/BasicTitle";
import { BasicBeneficiary } from "./components/basic/BasicContact";

interface Props {
  selectedCompany: Company;
  currentEmployee: Employee;
  backgroundColor: string;
  cvTemplate: LabelTemplate;
}
function OxagonTwoTemplate({
  selectedCompany,
  currentEmployee,
  backgroundColor,
  cvTemplate,
}: Props) {
  //a08745;f2f1f0 fffcf2
  return (
    <>
      <Box id="personalData" sx={{ p: 1 }}>
        <Grid
          container
          spacing={cvTemplate.spacing}
          sx={{
            p: 1,
            backgroundColor: backgroundColor,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{
              height: "90%",
              mb: 1,
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={cvTemplate.spacing}
            justifyContent="center"
            alignItems="center"
          >
            {/* Short Photo */}

            <Grid item xs={12}>
              <BasicTitleSingleLang template={cvTemplate} />
            </Grid>
            <Grid container item xs={9}>
              {cvTemplate && currentEmployee && (
                <>
                  <Grid item xs={6}>
                    <BasicReferenceOnly
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                    />
                  </Grid>

                  <Grid item xs={12} sx={{ mt: 1 }}>
                    <BasicFullName
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <BasicPostApplied
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showProfession={true}
                      showSalary={false}
                      showContractPeriod={false}
                      showEmployeeTelephone={true}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <BasicPassport
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={true}
                      showPassportNumber={false}
                      showIssueDate={false}
                      showPlaceOfIssue={false}
                      showExpiryDate={false}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BasicPassport
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showPassportNumber={false}
                      showIssueDate={true}
                      showPlaceOfIssue={false}
                      showExpiryDate={true}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <BasicPassport
                      currentEmployee={currentEmployee}
                      template={cvTemplate}
                      showHeader={false}
                      showPassportNumber={true}
                      showIssueDate={false}
                      showPlaceOfIssue={true}
                      showExpiryDate={false}
                    />
                  </Grid>
                </>
              )}
            </Grid>

            <Grid item xs={3}>
              {cvTemplate && currentEmployee && (
                <BasicFace
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              )}
            </Grid>
          </Grid>

          <Grid item md={7} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicDetail
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={true}
                  showReference={false}
                  showNationality={true}
                  showPassportNumber={false}
                  showReligion={true}
                  showDateOfBirth={true}
                  showAge={true}
                  showPlaceOfBirth={false}
                  showMaritalStatus={true}
                  showNumberOfChildren={true}
                  showWeightHeight={true}
                  showComplexion={false}
                  showEducation={true}
                  showLivingTown={false}
                  showEmployeeTelephone={false}
                  showContactName={false}
                  showContactTelephone={false}
                  showYearGraduated={true}
                  showGraduatedSchool={true}
                />

                <BasicExperience
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  type="onlyOneExperience"
                />

                <BasicLanguageLevels
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showEducation={true}
                />
                <BasicSkillsSmallHorzTwoLines
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
              </>
            )}
          </Grid>
          <Grid item md={5} xs={12}>
            {cvTemplate && currentEmployee && (
              <>
                <BasicStand
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                />
                <BasicBeneficiary
                  currentEmployee={currentEmployee}
                  template={cvTemplate}
                  showHeader={false}
                />
              </>
            )}
          </Grid>
          <Grid item xs={12}>
            {cvTemplate && currentEmployee && (
              <Image src="/oxagonCvFooter.jpeg" alt="oxagon Cv Footer" />
            )}
          </Grid>
        </Grid>
      </Box>
      <Stack
        id="passportData"
        sx={{
          p: 1,
          pt: 1,
          backgroundColor: backgroundColor,
          minHeight: "1500px",
        }}
      >
        {cvTemplate.addPassportHeader && (
          <Box
            sx={{
              height: "90%",
            }}
          >
            {cvTemplate && currentEmployee && (
              <BasicHeader
                selectedCompany={selectedCompany}
                currentEmployee={currentEmployee}
                template={cvTemplate}
              />
            )}
          </Box>
        )}
        {cvTemplate && currentEmployee && (
          <Box
            sx={{
              mt: 15,
            }}
          >
            <BasicPassportScan
              currentEmployee={currentEmployee}
              template={cvTemplate}
            />
          </Box>
        )}
      </Stack>
    </>
  );
}

export default OxagonTwoTemplate;
